import { render, staticRenderFns } from "./ValueEditor.vue?vue&type=template&id=674b3200&scoped=true"
import script from "./ValueEditor.vue?vue&type=script&lang=js"
export * from "./ValueEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b3200",
  null
  
)

export default component.exports